import React, { Component, Fragment } from 'react'
import FICRestV2 from 'FICRestV2'
import styled, { css } from 'styled-components'
import FICColors from 'FICColors'
import FICAutocomplete from 'FICAutocomplete'
import { FALIcon } from 'FAIcon'
import { Parser as HtmlToReactParser } from 'html-to-react'

export default class Autocomplete extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: '',
      searchResults: undefined,
      open: false,
      topArticles: []
    }
    this.autocompleteRef = null
    this.getTopArticles()
  }

  search = (filter, callback) => {
    if (filter === null) {
      return
    }

    if (filter.length < 3) {
      this.setState({ searchResults: undefined })
      return
    }

    const isDev = window.location.host.includes('-dev') ? 1 : 0

    FICRestV2.get({
      request: 'help/search',
      queryData: { query: filter, realm: this.props.realm, is_dev: isDev },
      onSuccess: response => {
        const results = response.data.map(item => {
          return { id: item.article_id, label: item.title, tree: item.tree }
        })
        this.setState({ searchResults: results })
      }
    })
  }

  handleChange = (name, value) => {
    let newValue = value.toString()
    newValue = newValue.replace(/<[^>]*>/g, '')
    this.setState({ filter: newValue })
  }

  handleSelect = (label, data) => {
    this.props.onSelect(data.permalink || data.tree.permalink, 'articolo')
    this.changeSize()
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') { this.autocompleteRef.autocompleteRef.setState({ isOpen: true }) }
  }

  renderItem = (item) => {
    const htmlToReactParser = new HtmlToReactParser()
    return <Option key={item.id}>
      {htmlToReactParser.parse(item.label)}
      {item.tree &&
      <Tree>
        {item.tree.section3_title &&
        <Fragment>
          <span>{item.tree.section3_title}</span>
          <FALIcon name='long-arrow-right' />
        </Fragment>
        }
        {item.tree.section2_title &&
        <Fragment>
          <span>{item.tree.section2_title}</span>
          <FALIcon name='long-arrow-right' />
        </Fragment>
        }
        {item.tree.section1_title &&
        <span>{item.tree.section1_title}</span>
        }
      </Tree>
      }
    </Option>
  }

  changeSize = () => {
    this.setState(currentStatus => ({ open: !currentStatus.open }), () => {
      if (this.state.open && this.autocompleteRef) {
        setTimeout(() => {
          this.autocompleteRef.focus()
        }, 200)
      }
    })
    if (this.props.onOpen) {
      this.props.onOpen(!this.state.open)
    }
  }

  getTopArticles = () => {
    FICRestV2.get({
      request: 'help/top_articles',
      queryData: { realm: this.props.realm },
      onSuccess: (response) => {
        this.setState({ topArticles: response.data })
      }
    })
  }

  renderMenuContent = (items) => {
    return (
      <Results open={this.state.open} internal={this.props.internal}>
        {this.state.searchResults
          ? this.state.searchResults.length > 0
            ? <div className='searchResultsHeader'>
              <p>Risultati della ricerca</p>
            </div>
            : <div className='noResults'>
              <p>Nessun risultato!</p>
              <img srcSet='/img/no-results.png 3x' />
            </div>
          : null
        }
        {items.length > 0 && items}
        {this.state.topArticles.length > 0 &&
        <TopArticles>
          <p>Ti potrebbe interessare</p>
          <ul>
            {this.state.topArticles.map((article, idx) => {
              return (
                <li key={idx} onClick={() => this.handleSelect(undefined, article)}>
                  <span>{article.title}</span>
                </li>
              )
            })
            }
          </ul>
        </TopArticles>
        }
      </Results>
    )
  }

  render () {
    let placeholder = this.props.internal ? 'Cerca in Fatture in Cloud' : 'Cosa stai cercando? (Fatturazione elettronica, prima nota etc.)'
    if (this.props.realm === 'dic') { placeholder = this.props.internal ? 'Cerca in Dipendenti in Cloud' : 'Cosa stai cercando? (Giustificativi, dipendente etc.)' }

    return (
      <AutocompleteContainer
        internal={this.props.internal}
        open={this.state.open}
        isExternal={this.props.isExternal}
        className={(this.state.open ? 'open ' : '') + this.props.className}
      >
        <FALIcon name='search' onClick={this.props.internal ? () => this.changeSize() : null} />
        <AutocompleteStyled
          ref={ref => this.autocompleteRef = ref}
          placeholder={placeholder}
          value={this.state.filter}
          options={this.state.searchResults}
          loadOptions={this.search}
          loadOptionsDelay={200}
          renderItem={this.renderItem}
          onSelect={this.handleSelect}
          onChange={this.handleChange}
          renderMenuContent={this.renderMenuContent}
          internal={this.props.internal}
          open={this.state.open}
          shouldItemRender={() => {
            return true
          }}
          onKeyPress={this.handleKeyPress}
        />
        {this.props.internal &&
        <FALIcon name='times-circle' className='close' onClick={this.props.internal ? () => this.changeSize() : null} />
        }
      </AutocompleteContainer>
    )
  }
}

const AutocompleteContainer = styled.div`
  height: 63px;
	width: 625px;
	max-width: 100%;
	${props => props.isExternal && css`
    width: 780px;
  `};
	border-radius: 4px;
	background-color: ${FICColors.white};
	box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);
	position: relative;
	margin-top: 15px;
	-webkit-transition: all 200ms ease-out; /* For Safari 3.1 to 6.0 */
  transition: all 200ms ease-out;
	.fa, .faicon{
    font-size: 24px!important;
    color: #333!important;
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 100;
    &.close{
      right:5px;
      left: auto;
      opacity: 1;
      display: none;
    }
	}
	${props => props.internal && css`
    width: 50px;
    margin: 0;
    max-height: 100%;
    box-sizing: border-box;
    box-shadow: none;
    position: absolute;
    top:0;
    right: 0;
    .fa, .faicon{
      cursor: pointer;
      ${props => props.open && css`
        margin-left: 0!important;
        left:5px;
      `}
    }
    ${props => props.open && css`
      width: 100%;
      .fa.close,
      .faicon.close{
        display: block;
        margin-right: 0;  
      } 
    `}
    `
}
`

const AutocompleteStyled = styled(FICAutocomplete)`
  height: 100%;
  input{
    width: 99%;
    box-sizing: border-box;
    height: 63px;
    border: none!important;
    padding-left: 50px!important;
    font-size: 16px!important;
    &:focus{box-shadow: none!important;}
    &::placeholder{font-size: 16px!important;}
    ${props => props.internal && css`
      height: 100%;
      padding-right:50px;
      display:none;
    `}
    ${props => props.open && css`
      display: block;
    `}
  }
  .fic-autocomplete-menu-outer{
    margin-top: 4px!important;
  }
`
const Option = styled.div`
  color: rgba(51,51,51,0.72);
  background-color: ${FICColors.white};
  border-radius: 4px;
  padding: 12px 0 12px 40px!important;
  font-size: 16px!important;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  &:hover{
    color: ${FICColors.defaultBlue}!important;
    background-color: #FAFAFA!important;
  }
`

const Results = styled.div`
  text-align: center;
  background-color: ${FICColors.white};
  border-radius: 4px;
	box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);
	margin-top: 5px;
	${props => (props.internal && !props.open) && css`
    display: none;
    color:red;
  `}
  p{
	  padding-top: 10px;
    font-weight: bold;
    color:${FICColors.textDefault};
    font-size: 16px;
    margin-bottom: 10px;
  }
  .noResults{
    p{
      padding: 20px 0;
      margin-bottom: 0;
      font-size: 20px;
      font-weight: 600;
    }
  }
  .searchResultsHeader{
    text-align: left;
    margin-left: 40px;
    text-transform: uppercase;
    padding-top: 5px;
    p{
      font-size: 12px;
      color: #0094D4!important;
    }
  }
`

const TopArticles = styled.div`
  border-top:1px solid rgba(51,51,51,0.08);
  padding: 24px 65px;
  box-sizing: border-box;
  text-align: left;
  @media (max-width: 425px) {
    padding: 16px 16px;
  }
  p{
    margin-top: 0;
    font-size: 18px;
    margin-bottom: 24px;
    
  }
  ul{
    padding: 0;
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
    -moz-column-gap: 40px; /* Firefox */
    column-gap: 40px;
    margin-left: 10px;
    li{
      color: ${FICColors.textDefault};
      margin-bottom: 12px;
      margin-left:10px;
      font-size: 16px;
      line-height: 25px;
      width: 100%;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      @media (max-width: 425px) {
        font-size: 14px;
        line-height: 20px;
      }
      span{
        cursor: pointer;
        color: ${FICColors.defaultBlue};
        &:hover{
          text-decoration: underline;
          &::before {text-decoration: none;}
        }
      }
    }
  }
`

const Tree = styled.div`
	height: 16px;
	color: rgba(51,51,51,0.72);
	font-size: 12px;
	letter-spacing: -0.13px;
	line-height: 16px;
	.fa, .faicon{
    position: unset;
    font-size: 12px!important;
    margin: 0 5px!important;
    color: rgba(51,51,51,0.72)!important;
	}
`



// WEBPACK FOOTER //
// ./src/help/common/Autocomplete.js